import Layout from '@/components/feature/Layout';
import { usePageMeta } from '@/hooks/usePageMeta';
import HeroCarousel from './components/HeroCarousel';
import CategoryGrid from './components/CategoryGrid';
import LatestTopics from './components/LatestTopics';
import ActiveUsers from './components/ActiveUsers';
import SidePanel from './components/SidePanel';

export default function Home() {
  usePageMeta({
    title: '蜜糖社区 - 热门话题交流与兴趣分享平台',
    description: '蜜糖社区为用户提供多元化的兴趣交流空间，涵盖生活、娱乐、文化等多个领域，方便大家在线分享经验，互动讨论。',
    keywords: '蜜糖社区,社区论坛,兴趣交流,生活分享,互动讨论,话题社区',
  });

  return (
    <Layout>
      <h1 className="sr-only">蜜糖社区 - 兴趣话题交流与分享平台</h1>
      <HeroCarousel />

      <div className="w-full max-w-page mx-auto px-4 md:px-6 lg:px-8 py-10 md:py-14 flex flex-col gap-12 md:gap-16">
        <CategoryGrid />

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 lg:gap-10">
          <div className="lg:col-span-2">
            <LatestTopics />
          </div>
          <aside className="lg:col-span-1 flex flex-col gap-5">
            <ActiveUsers />
            <SidePanel />
          </aside>
        </div>
      </div>
    </Layout>
  );
}